import React, { Fragment } from 'react';

import { ValueGroup } from '@candu-ai/craft/ui';
import { CollectionLockedSetting } from '@candu-ai/editor-nodes/collection-settings';
import { getInteractionFromAction } from 'craft/containers/Actions/useAvailableInteractions';
import { Action, CollectionTargetLocation, ContentCollection } from 'craft/types';

import { InteractionDropdown } from './InteractionDropdown';
import { InteractionLabelDropdown } from './InteractionLabelDropdown';
import { interactionFields } from './fields/interactionFields';

interface Props {
  action: Action;
  updateAction: (action: any) => void;
  removeAction: () => void;
  collection?: ContentCollection;
  nodeIds: string[];
}

export const ActionForm = ({ action, updateAction, removeAction, collection, nodeIds }: Props) => {
  const interaction = getInteractionFromAction(action);
  const Field = interactionFields[interaction];

  const updateActionCategory = (data: Action) => {
    if (!data) {
      removeAction();
      return;
    }
    updateAction(data);
  };

  const updateActionField = (data: Action['handler']) => updateAction({ ...action, handler: data });

  return (
    <Fragment>
      <ValueGroup>
        {collection && (
          <CollectionLockedSetting
            collectionId={collection.collectionId}
            targetLocation={CollectionTargetLocation.ActionURL}
          />
        )}

        {!collection && (
          <InteractionDropdown
            onChange={updateActionCategory}
            nodeIds={nodeIds}
            noRadiusBottom
            action={action}
            isStandalone={!action.handler || !Field}
          />
        )}

        {!!Field && (
          <Field
            onChange={updateActionField as any}
            collection={collection}
            defaultValue={action.handler as any}
            nodeIds={nodeIds}
          />
        )}
      </ValueGroup>
      <ValueGroup label="Interaction label">
        <InteractionLabelDropdown
          value={action.eventName as string}
          onChange={(eventName: string) => updateAction({ ...action, eventName })}
        />
      </ValueGroup>
    </Fragment>
  );
};
